module.exports = __webpack_public_path__ + "static/activities-e640f57a21e96334388c8fd5526fd615.jpg";